import React from 'react';
import ISVGIcon from './interfaces/ISVGIcon';

const CrossChunky = ({ fill }: ISVGIcon): React.ReactElement => (
    <svg viewBox="0 0 24 24">
        <polygon
            fill={fill}
            points="13.4,12 16.9,8.5 15.5,7.1 12,10.6 8.5,7.1 7.1,8.5 10.6,12 7.1,15.5 8.5,16.9 12,13.4 15.5,16.9 16.9,15.5 "
        />
    </svg>
);

export default CrossChunky;
